import { createFileRoute } from '@tanstack/react-router';

import Chart3D from '@/components/Chart3D';
import { ConfigureChartButton } from '@/components/ConfigureChartButton';
import { DownloadButton } from '@/components/DownloadButton';
import { RangeFilterButton } from '@/components/RangeFilterButton';
import { useChartTitle } from '@/contexts/ChartContext';
import { mixedStrategyData } from '@/data/mixedStrategyData';
import { useChartDefaults } from '@/hooks/useChartDefaults';
import { usePageActions } from '@/hooks/usePageActions';
import { buildChartHeadMeta } from '@/lib/headMeta';

export const Route = createFileRoute('/mixed-strategy')({
  component: MixedStrategyRoute,
  head: () => buildChartHeadMeta({ chartData: mixedStrategyData, ogImagePath: '/og/mixed-strategy.png' }),
});

function MixedStrategyRoute() {
  useChartTitle(mixedStrategyData);

  // Use categorical color scheme for actions and show legend
  useChartDefaults({
    colorScheme: 'GTO_ACTIONS',
    useLogScale: false,
    showLegend: true,
    maxHeight: 1.0,
    segmentLayout: 'bookcase',
  });

  usePageActions({
    secondary: () => (
      <>
        <RangeFilterButton />
        <DownloadButton />
      </>
    ),
    primary: () => <ConfigureChartButton />,
  });

  return <Chart3D data={mixedStrategyData} />;
}
